import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as PackageInventoryStore from '../../../redux/packageInventory';
import { FilterPanel } from '../../generic';
import useFetchPackages from '../hooks/useFetchPackages';
import type { WithResetSelectedPackage } from '../PackageInventoryContainer';
import VulnHasFix from './VulnHasFix';
import VulnSeverity from './VulnSeverity';
import VulnCVE from './VulnCVE';
import VulnCWE from "./VulnCWE";

type Props = {
  withResetSelectedPackage: WithResetSelectedPackage;
};

/**
 * PackageInventoryFiltersVuln has filters related to
 * searching packages by vuln CVE, CWE, severity, and fixability.
 */
const PackageInventoryFiltersVuln: VoidFunctionComponent<Props> = ({ withResetSelectedPackage }) => {
  const setFilters = useFetchPackages(PackageInventoryStore.actions.setFilters);
  const cve = useSelector(PackageInventoryStore.selectors.getFiltersVulnCVE);
  const cwes = useSelector(PackageInventoryStore.selectors.getFiltersVulnCWEs);
  return (
    <FilterPanel title="Vulnerabilities">
      <VulnCVE cve={cve} setFilters={withResetSelectedPackage(setFilters)} />
      <VulnCWE cwes={cwes} setFilters={withResetSelectedPackage(setFilters)} />
      <VulnSeverity setFilters={withResetSelectedPackage(setFilters)} />
      <VulnHasFix setFilters={withResetSelectedPackage(setFilters)} />
    </FilterPanel>
  );
};

export default PackageInventoryFiltersVuln;
